import React from 'react';
import Icon from '../../../components/AppIcon';

const SeasonalDemandChart = () => {
  const monthlyData = [
    { month: 'Jan', demand: 85, trend: 'stable' },
    { month: 'Feb', demand: 82, trend: 'down' },
    { month: 'Mar', demand: 88, trend: 'up' },
    { month: 'Apr', demand: 90, trend: 'up' },
    { month: 'Mei', demand: 87, trend: 'down' },
    { month: 'Jun', demand: 92, trend: 'up' },
    { month: 'Jul', demand: 95, trend: 'up' },
    { month: 'Agu', demand: 93, trend: 'down' },
    { month: 'Sep', demand: 89, trend: 'down' },
    { month: 'Okt', demand: 91, trend: 'up' },
    { month: 'Nov', demand: 88, trend: 'down' },
    { month: 'Des', demand: 94, trend: 'up' }
  ];

  const maxDemand = Math.max(...monthlyData?.map(d => d?.demand));

  const seasonalInsights = [
    {
      title: 'Puncak Permintaan',
      value: 'Juli - Desember',
      description: 'Periode permintaan tertinggi',
      icon: 'TrendingUp',
      color: 'text-success'
    },
    {
      title: 'Permintaan Rendah',
      value: 'Februari - Mei',
      description: 'Periode permintaan terendah',
      icon: 'TrendingDown',
      color: 'text-warning'
    },
    {
      title: 'Fluktuasi',
      value: '±8%',
      description: 'Variasi permintaan tahunan',
      icon: 'Activity',
      color: 'text-primary'
    }
  ];

  return (
    <div className="space-y-6">
      {/* Chart */}
      <div className="bg-card rounded-xl border border-border p-6">
        <h3 className="text-lg font-semibold text-foreground mb-6 flex items-center gap-2">
          <Icon name="BarChart3" size={20} color="var(--color-primary)" />
          Pola Permintaan Musiman
        </h3>
        
        <div className="space-y-3">
          {monthlyData?.map((data, index) => (
            <div key={index} className="space-y-1">
              <div className="flex items-center justify-between text-sm">
                <span className="text-muted-foreground font-medium w-12">{data?.month}</span>
                <div className="flex-1 mx-4">
                  <div className="h-8 bg-muted rounded-lg overflow-hidden relative">
                    <div 
                      className="h-full bg-gradient-to-r from-primary to-accent transition-all duration-500 flex items-center justify-end pr-2"
                      style={{ width: `${(data?.demand / maxDemand) * 100}%` }}
                    >
                      <span className="text-xs font-semibold text-white data-text">{data?.demand}%</span>
                    </div>
                  </div>
                </div>
                <Icon 
                  name={data?.trend === 'up' ? 'ArrowUp' : data?.trend === 'down' ? 'ArrowDown' : 'Minus'} 
                  size={16}
                  className={
                    data?.trend === 'up' ? 'text-success' : 
                    data?.trend === 'down'? 'text-error' : 'text-muted-foreground'
                  }
                />
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Seasonal Insights */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {seasonalInsights?.map((insight, index) => (
          <div key={index} className="bg-card rounded-xl border border-border p-5">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
                <Icon name={insight?.icon} size={20} color="var(--color-primary)" />
              </div>
              <h4 className="text-sm font-semibold text-foreground">{insight?.title}</h4>
            </div>
            <p className={`text-xl font-bold ${insight?.color} mb-1`}>{insight?.value}</p>
            <p className="text-xs text-muted-foreground">{insight?.description}</p>
          </div>
        ))}
      </div>
      {/* Demand Forecast */}
      <div className="bg-gradient-to-br from-accent/10 to-primary/10 rounded-xl border border-border p-6">
        <div className="flex items-start justify-between mb-4">
          <div>
            <h3 className="text-lg font-semibold text-foreground mb-1">Proyeksi Permintaan 2026</h3>
            <p className="text-sm text-muted-foreground">Berdasarkan tren historis dan pertumbuhan pasar</p>
          </div>
          <Icon name="Calendar" size={24} color="var(--color-primary)" />
        </div>
        <div className="flex items-end gap-4">
          <div className="flex-1">
            <div className="flex items-center gap-2 mb-2">
              <Icon name="TrendingUp" size={16} className="text-success" />
              <span className="text-sm text-muted-foreground">Pertumbuhan proyeksi</span>
            </div>
            <div className="h-3 bg-background rounded-full overflow-hidden">
              <div className="h-full bg-gradient-to-r from-success to-primary w-3/4 transition-all duration-500" />
            </div>
          </div>
          <div className="text-right">
            <p className="text-2xl font-bold text-success data-text">+12%</p>
            <p className="text-xs text-muted-foreground">YoY Growth</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SeasonalDemandChart;